import TripTravellerAllocationPassengerModule from './trip-traveller-allocation-passenger/trip-traveller-allocation-passenger-module';

import TripTravellerAllocationFlight from './trip-traveller-allocation-flight-component';
import TripTravellerAllocationFlightService from './trip-traveller-allocation-flight-service';

import './trip-traveller-allocation-flight.scss';

const MODULE_NAME = 'app.trip.traveller-allocation.flight';
const module = angular.module(MODULE_NAME, [
        TripTravellerAllocationPassengerModule,
    ])
    .directive(TripTravellerAllocationFlight.DIRECTIVE_NAME, TripTravellerAllocationFlight)
    .service('tripTravellerAllocationFlightService', TripTravellerAllocationFlightService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-segment/trip-traveller-allocation-flight/trip-traveller-allocation-flight-module.js